//let host = process.env.REACT_APP_API          //.ENV
//let host = "apilandingsmx.grupomok.com"       //PRODUCCION
//let host = "preapilandingsmx.grupomok.com"    //PRE
let host = process.env.REACT_APP_API 
let gate = "api";

export const URL = `https://${host}/${gate}`;

export const COD_TAG_MANAGER = 'GTM-PNNR458'
